var _g, _g2, _path, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgNoSmoking = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 49"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 48"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 47"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 275",
  d: "M376 151a15 15 0 01-15-15 15.017 15.017 0 00-15-15h-60a45.051 45.051 0 01-45-45 15 15 0 0130 0 15.017 15.017 0 0015 15h60a45.051 45.051 0 0145 45 15 15 0 01-15 15z",
  fill: "#dfdef5"
}))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 53"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 52"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 51"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 276",
  d: "M178.552 268.762l-98.668 35.912a15 15 0 00-8.965 19.226L84.6 361.488a15 15 0 0019.226 8.965l98.668-35.912 2.125-38.02z",
  fill: "#ffcd00"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 277",
  d: "M84.6 361.488a15 15 0 0019.226 8.965l98.668-35.912 2.125-38.02L77.76 342.694z",
  fill: "#ff9f22"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 278",
  d: "M206.743 258.5l-2.125 38.02 26.066 27.759L409.226 259.3a15 15 0 008.965-19.226l-13.681-37.591a15 15 0 00-19.226-8.965z",
  fill: "#fff5f5"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 279",
  d: "M204.618 296.521l26.066 27.759 178.542-64.98a15 15 0 008.965-19.226l-6.84-18.794z",
  fill: "#dfdef5"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 280",
  d: "M418.174 181.547l-32.889 11.971 23.941 65.782 32.889-11.971a15 15 0 008.965-19.229l-13.68-37.588a15 15 0 00-19.226-8.965z",
  fill: "#ed6c7b"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 50"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 281",
  d: "M178.53 268.795l28.192-10.257 23.933 65.781-28.192 10.257z",
  fill: "#dfdef5"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 282",
  d: "M190.493 301.688l28.192-10.257 11.967 32.89-28.192 10.258z",
  fill: "#c1bde0"
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 283",
  d: "M397.255 226.407l11.971 32.893 32.889-11.971a15 15 0 008.965-19.229l-6.84-18.8z",
  fill: "#d65b72"
}))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 284",
  d: "M437.02 74.98A256 256 0 0074.98 437.02 256 256 0 00437.02 74.98zM482 256a225.048 225.048 0 01-56.019 148.767L107.233 86.02A225.047 225.047 0 01256 30c124.617 0 226 101.383 226 226zm-452 0a225.047 225.047 0 0156.02-148.767L404.768 425.98A225.052 225.052 0 01256 482C131.383 482 30 380.617 30 256z",
  fill: "#ed6c7b"
})), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 55"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 54"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 285",
  d: "M437.02 74.98A254.331 254.331 0 00256 0v30c124.617 0 226 101.383 226 226a225.048 225.048 0 01-56.019 148.767L256 234.787v42.426L404.768 425.98A225.052 225.052 0 01256 482v30A256 256 0 00437.02 74.98z",
  fill: "#d65b72"
})))));
export default SvgNoSmoking;